import React, { useState } from "react"
import { Footer } from "./Footer"
import { Header } from "./Header"
import { Side } from "./Side"
import { isMobile } from "react-device-detect"
import "../../styles/layout.scss";
import "../../styles/layout-mobile.scss";

export const Layout = ({ children }) => {

    const [collapsed, setCollapsed] = useState(() => {
        const savedState = localStorage.getItem('sidebar_collapsed');
        return savedState === 'true';
    });

    const handleCollapse = () => {
        setCollapsed(!collapsed);
        localStorage.setItem('sidebar_collapsed', String(!collapsed));
    };

    return (
        <React.Fragment>
            {!isMobile ?
                <div className="layout__wrapper">
                    <Side collapsed={collapsed} />
                    <Header collapsed={collapsed} onToggle={handleCollapse} />
                    <div className={`layout__content ${!collapsed ? "layout__content__collapsed" : ""}`}>
                        {children}
                    </div>
                    <Footer />
                </div>
                : <>
                    <Header />
                    <div className="layout-mobile__content">
                        {children}
                    </div>
                    <Footer />
                </>
            }
        </React.Fragment>
    )
}